import { useEffect, useState } from "react";
import { Banner } from "../../types/Banner";
import { HttpBanner } from "../../http";

export const useMiddleBanners = () => {
    const [banners, setBanners] = useState<Banner[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchBanners = async () => {
            setLoading(true);
            try {
                const data = await HttpBanner.getBannersByPosition("middle");
                setBanners(data);
            } catch (e) {
                console.error(e);
                setError("Error cargando banners");
            } finally {
                setLoading(false);
            }
        };

        fetchBanners();
    }, []);

    return { banners, loading, error };
};














